// export constants that we use in the rest of the program to avoid working with strings.
export const getProgramsColumnTypes = "getProgramsColumnTypes"
export const getProgramsMeasures = "getProgramsMeasures"
export const getProgramsProviders = "getProgramsProviders"
export const executeExportProgramsQuery = "executeExportProgramsQuery"
export const executeProgramsRoFQuery = "executeProgramsRoFQuery"
export const executeProgramsRoFExport = "executeProgramsRoFExport"
export const executeProgramsQuery = "executeProgramsQuery"
export const getProgramsGenres = "getProgramsGenres"
export const executeTopProgramsLatestDayQuery = "executeTopProgramsLatestDayQuery"
export const executeScheduleQuery = "executeScheduleProgramsQuery";
